import { Box, Button, Text, VStack } from '@chakra-ui/react'

import { withPage } from '@/features/layout'
import { useState } from 'react'
import { Select } from '@/components/Select'
import { Option, useCompanyOptions } from '../../queries/getCompanyOptions'
import { Controller, useForm } from 'react-hook-form'

type Props = {}
type AdminCompanyForm = {
  company: Option
}

function AdminCompanyPage(_props: Props) {
  const [search, setSearch] = useState<string>()
  const { data, isLoading } = useCompanyOptions({ search })
  const { control, handleSubmit } = useForm()

  const onSubmit = (data: AdminCompanyForm) => {
    window.location.href = `/admins/companies/${data.company.value}/consents`
  }

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <VStack alignItems="flex-start" gap="16px" width="400px">
        <Text as="h3" fontWeight="medium" color="gray.900">
          Search and select company to view dashboard
        </Text>
        <form
          onSubmit={handleSubmit(onSubmit)}
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          <Controller
            name="company"
            control={control}
            render={({ field: { onChange, name } }) => {
              return (
                <Select
                  name={name}
                  isSearchable
                  isClearable
                  isLoading={isLoading}
                  options={data || []}
                  onInputChange={(val) => setSearch(val)}
                  onChange={onChange}
                  styles={{
                    container: (provided) => ({ ...provided, width: '100%' }),
                  }}
                />
              )
            }}
          />
          <Button
            type="submit"
            sx={{
              width: '100%',
              height: '40px',
            }}
          >
            Submit
          </Button>
        </form>
      </VStack>
    </Box>
  )
}

export default withPage(AdminCompanyPage)
